import React from 'react';
import { withGoogleMap, GoogleMap } from 'react-google-maps';
 
const GGMap = ({ children, center, onMapMounted = null, ...restProps }) => (
    <GoogleMap
        ref={onMapMounted}
        zoom={14}
        center={center} 
        {...restProps}
    >
        {children}
    </GoogleMap>
)        

export const GMap = withGoogleMap(GGMap);

const fullheight = { height: `100%`};

const defaultcenter = {lat: 13.0827, lng: 80.2707};

const Map = ({children, center ,  ...restProps}) => (
    <div className="map-container">
        <GMap
            containerElement={<div style={fullheight} />}
            mapElement={<div style={fullheight} />}
            center={center || defaultcenter}
            {...restProps}
        >
            {children}
        </GMap>
    </div>
)

export default Map;